module.exports = __webpack_public_path__ + "static/media/8OLA23.f17a1586.jpg";